import { getDashboardCount } from 'lib/api/dashboard';
import { useQuery } from 'react-query';
import useLoginCheck from './useLoginCheck';

const useDashboardCount = () => {
  const { isLoading, error, data, refetch } = useQuery(
    'dashboardCounts',
    getDashboardCount,
  );
  useLoginCheck(error?.response, refetch);
  const dashboardCounts = data?.data;

  return { isLoading, error, dashboardCounts };
};

export default useDashboardCount;
